import { RunTimelineInput } from 'src/components/dispatch/autoDispatch/useAutoDispatchController';
import { TimelineRequestEntity } from 'src/entities/TimelineRequest.entity';

/**
 * 現行 `Presenter.tsx:1810-1841` と `:1953-1966` の判断を 1 つにまとめる。
 *
 * Why not 本体を値で受ける: 現行は純 unassign のとき本体を生成する前に return する。
 * 値で受けると常に生成することになり、呼び出しを 2 か所に割るしかなくなる。
 *
 * Why not controller 側で導出する: 純 unassign のとき現行は emptyDeliveryIds を
 * 計算しないので、controller の「両方空」条件では区別できない。
 */
export function buildTimelineRunInput(params: {
  /**
   * reset 対象を除く前の変更 legRun。**非空であること**（空のときは現行 `:1804` が
   * `runTimeline` を呼ぶ前に return する）。この前提があるので
   * `remaining.size === 0` は「drop があってそれ以外に変更が無い」と同義になる。
   */
  changedLegRunIds: ReadonlySet<number>;
  /** 配車済み → 未割当のドロップ */
  unassignedDropIds: number[];
  /**
   * 純 unassign のときは呼ばれない。
   * **引数は reset 対象を除いたあとの集合**（現行 `:1833` の `delete` 後）。
   * 元の `changedLegRunIds` から作ると、戻したはずの legRun を timeline に送り返す。
   */
  buildBody: (remaining: ReadonlySet<number>) => {
    timelineEntities: TimelineRequestEntity[]; emptyDeliveryIds: number[];
  };
}): RunTimelineInput {
  const remaining = new Set(params.changedLegRunIds);
  params.unassignedDropIds.forEach((id) => remaining.delete(id));

  // 現行 :1835 の `changedLegRunIds.size === 0`（drop を除いたあと）
  const isUnassignOnly = remaining.size === 0;
  const body = isUnassignOnly
    ? { timelineEntities: [], emptyDeliveryIds: [] }
    : params.buildBody(remaining);

  return { ...body, resetLegRunIds: params.unassignedDropIds, isUnassignOnly };
}
